import { CaracteristiqueChoixTemplateUpdate } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const CaracteristiqueChoixTemplateActions = createActionGroup({
  source: 'Caracteristique Choix Template',
  events: {
    'Handle Many Caracteristique Choix Template': props<CaracteristiqueChoixTemplateUpdate>()
  }
});
